import React from 'react';
import Badge from '../../../commons/DataTableFields/Badge';

const DisponibilityField = ({ value, data, ...props }) => {
  return (
    <div className={data._id ? 'master-yes' : 'master-no'}>
      <Badge>
        {data._id ? 'Documento caricato' : 'Documento non caricato'}
      </Badge>
    </div>
  );
};

export default DisponibilityField;
